"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
const theme_1 = require("../font/theme");
const dark_1 = require("../color/theme/dark");
exports.theme = {
    light: dark_1.theme.light,
    font: theme_1.theme,
    color: dark_1.theme,
};
